import React from 'react';

const CityView: React.FC = () => {
    return (
        <>
      
        </>
    );
}

export default CityView;